'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import DashboardProgramSkeleton from './dashboard-program-skeleton';

const AnalysisSkeleton = () => {
    return (
        <>
            <div className='mb-4'>
                <div className='flex min-h-4 animate-pulse items-center gap-1.5 leading-loose'>
                    <div className='h-5 w-14 bg-gray-200 font-medium' />
                    <div className='h-5 w-16 rounded bg-gray-200' />
                </div>
            </div>
            <div className='mb-6 -ml-5 sm:-ml-6'>
                <ProgramCalendarSkeleton />
            </div>
            <div className='space-y-6'>
                <MentorNoteHeaderSkeleton />
                <DashboardProgramSkeleton />
            </div>
        </>
    );
};

export default AnalysisSkeleton;

const ProgramCalendarSkeleton = () => {
    const skeletonDays = Array.from({ length: 10 });

    return (
        <Swiper
            spaceBetween={8}
            slidesPerView='auto'
            slidesOffsetAfter={12}
            slidesOffsetBefore={12}
            style={{ overflow: 'visible', overflowX: 'clip' }}
            className='rounded-r-2xl bg-gray-50'
        >
            {skeletonDays.map((_, idx) => (
                <SwiperSlide key={idx} style={{ width: 50 }} className='my-3'>
                    <div className='animate-pulse space-y-1 text-center'>
                        <div className='mx-auto h-20 w-14 rounded-full bg-gray-200'></div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

const MentorNoteHeaderSkeleton = () => {
    return (
        <div className='flex animate-pulse items-start justify-between'>
            <div className='space-y-2'>
                <div className='h-5 w-32 rounded bg-gray-200'></div>
                <div className='h-3 w-24 rounded bg-gray-200'></div>
            </div>
            <div className='h-6 w-20 rounded-full bg-gray-300'></div>
        </div>
    );
};

